"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_PLANNER_WEEK = exports.CLASS_PLANNER_MONTH = exports.CLASS_PLANNER_DAY_WITHIN = exports.CLASS_PLANNER_DAY_SELECTED_START = exports.CLASS_PLANNER_DAY_SELECTED_END = exports.CLASS_PLANNER_DAY_SELECTED = exports.CLASS_PLANNER_DAY_BOOKABLE_WITHIN = exports.CLASS_PLANNER_DAY_BOOKABLE_OUTSIDE = exports.CLASS_PLANNER_DAY_BOOKABLE = exports.CLASS_PLANNER_DAY_BLOCKED = exports.CLASS_PLANNER_DAY = exports.CLASS_PLANNER_CONTAINER = void 0;
/*
 These class names are used to provide a means for style overrides by a third party stylesheet.
 Consider this an overview of stylable elements and a way to ensure these class names don't accidentally change or get
 deleted since they have external stylesheets relying on them. This should not replace theming but should provide more
 detailed control over the styles of some elements, mainly the search box iframe version that gets integrated into
 external websites.
 */

var CLASS_PLANNER_MONTH = exports.CLASS_PLANNER_MONTH = 'ext-planner__month';
var CLASS_PLANNER_WEEK = exports.CLASS_PLANNER_WEEK = 'ext-planner__week';
var CLASS_PLANNER_DAY = exports.CLASS_PLANNER_DAY = 'ext-planner__day';
var CLASS_PLANNER_CONTAINER = exports.CLASS_PLANNER_CONTAINER = 'ext-planner__day__container';
var CLASS_PLANNER_DAY_SELECTED = exports.CLASS_PLANNER_DAY_SELECTED = 'ext-planner__day-selected';
var CLASS_PLANNER_DAY_BLOCKED = exports.CLASS_PLANNER_DAY_BLOCKED = 'ext-planner__day-blocked';
var CLASS_PLANNER_DAY_SELECTED_START = exports.CLASS_PLANNER_DAY_SELECTED_START = 'ext-planner__day-selected-start';
var CLASS_PLANNER_DAY_SELECTED_END = exports.CLASS_PLANNER_DAY_SELECTED_END = 'ext-planner__day-selected-end';
var CLASS_PLANNER_DAY_WITHIN = exports.CLASS_PLANNER_DAY_WITHIN = 'ext-planner__day-within';
var CLASS_PLANNER_DAY_BOOKABLE = exports.CLASS_PLANNER_DAY_BOOKABLE = 'ext-planner__day-bookable';
var CLASS_PLANNER_DAY_BOOKABLE_WITHIN = exports.CLASS_PLANNER_DAY_BOOKABLE_WITHIN = 'ext-planner__day-bookable-within';
var CLASS_PLANNER_DAY_BOOKABLE_OUTSIDE = exports.CLASS_PLANNER_DAY_BOOKABLE_OUTSIDE = 'ext-planner__day-bookable-outside';
//# sourceMappingURL=customizationClassNames.js.map